import { useRef } from "react";
import { SideBarElementsType } from "@/common/types";
import TabElement from "./TabElement";
import { ChevronIcon } from "../icon";

export default function Tabs({ tabs }: { tabs: SideBarElementsType[] }) {
  const scrollContainerRef = useRef<HTMLDivElement>(null);

  const scrollLeft = () => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollBy({
        left: -300,
        behavior: "smooth",
      });
    }
  };

  const scrollRight = () => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollBy({
        left: 300,
        behavior: "smooth",
      });
    }
  };

  return (
    <div className="relative w-full max-w-[760px] scroll-none overscroll-none">
      {tabs.length > 7 && (
        <>
          <button
            onClick={scrollLeft}
            className="absolute -left-1 z-10 top-1/2 -translate-y-1/2 bg-white border hover:bg-primary hover:text-white transition border-primary text-primary px-3 py-3 rounded-lg font-extrabold text-2xl "
          >
            <ChevronIcon />
          </button>
          <button
            onClick={scrollRight}
            className="absolute rotate-180 z-10 -right-3 top-1/2 -translate-y-1/2 bg-white border hover:bg-primary hover:text-white transition border-primary text-primary px-3 py-3 rounded-lg font-extrabold text-2xl "
          >
            <ChevronIcon />
          </button>
        </>
      )}

      <div
        ref={scrollContainerRef}
        className="flex  scroll-smooth space-x-4 scrollbar-hide px-10 scroll-none overscroll-none overflow-x-auto scrollbar-hide withOutScroll"
      >
        {tabs.map((el: SideBarElementsType) => (
          <div key={el.label} className="w-full max-w-fit ">
            <TabElement element={el} key={el.to} />
          </div>
        ))}
      </div>
    </div>
  );
}
